export const QR_CODE_WIDTH = 200;
export const SHARE_CART_BY_QR_MODAL_TEST_ID = 'share-cart-by-qr-modal';
